import { Divider } from '@braskai/ui-kit';

import { List, Stack } from '@mui/material';

import { useInterfaceLanguage } from '@/shared/i18n';

import { NavigationItem } from '../NavigationItem';
import { DesktopNavigationProps } from './types';

export const DesktopNavigation = ({
  bottomNavigation,
  children,
  isOpen,
  logoContainer,
  mainNavigation,
  profileContainer,
  promoNavItems,
  teamspaceContainer,
  topNavigation,
  ...props
}: DesktopNavigationProps) => {
  const { t } = useInterfaceLanguage();

  return (
    <Stack aria-label={t('common.navigationSidebar')} component="nav" flexGrow={1} {...props}>
      {logoContainer}
      {teamspaceContainer}
      {topNavigation && topNavigation.length > 0 && (
        <List
          sx={{
            padding: '8px 10px',
          }}
        >
          {topNavigation.map(({ title, dataTestId, icon, path, selected, onClick }) => (
            <NavigationItem
              key={title}
              title={title}
              data-testid={dataTestId}
              dataTestId={dataTestId}
              icon={icon}
              path={path}
              selected={selected}
              onClick={onClick}
            />
          ))}
        </List>
      )}

      <Divider
        sx={{
          marginBottom: 8,
        }}
      />

      {mainNavigation && mainNavigation.length > 0 && (
        <List
          sx={{
            padding: '8px 10px',
          }}
        >
          {mainNavigation.map(({ title, dataTestId, icon, path, selected, onClick }) => (
            <NavigationItem
              key={title}
              title={title}
              data-testid={dataTestId}
              dataTestId={dataTestId}
              icon={icon}
              path={path}
              selected={selected}
              isMainMenu
              onClick={onClick}
            />
          ))}
        </List>
      )}

      {mainNavigation.length > 1 && (
        <Divider
          sx={{
            marginBottom: 8,
          }}
        />
      )}

      <List
        sx={{
          flexGrow: '1',
          padding: promoNavItems?.some((item) => item.isOutlined) ? '16px 10px 8px' : '8px 10px',
        }}
      >
        {promoNavItems &&
          promoNavItems.length > 0 &&
          promoNavItems.map(({ title, dataTestId, icon, isOutlined, path, rightText, selected, tag, onClick }) =>
            isOutlined && !isOpen ? null : (
              <NavigationItem
                key={title}
                title={title}
                data-testid={dataTestId}
                dataTestId={dataTestId}
                icon={icon}
                isOutlined={isOutlined}
                path={path}
                rightText={rightText}
                selected={selected}
                tag={isOpen ? tag : undefined}
                isMainMenu
                onClick={onClick}
              />
            ),
          )}
      </List>

      {children}

      {bottomNavigation && bottomNavigation.length > 0 && (
        <List
          sx={{
            padding: '8px 10px',
          }}
        >
          {bottomNavigation.map(({ title, dataTestId, icon, onClick }) => (
            <NavigationItem
              key={title}
              title={title}
              data-testid={dataTestId}
              dataTestId={dataTestId}
              icon={icon}
              onClick={onClick}
            />
          ))}
        </List>
      )}

      <Divider />

      {profileContainer}
    </Stack>
  );
};
